import { Dayjs } from "dayjs"

/**
 * Mirrors the `warrants_files_job_status` Postgres enum exposed by Hasura on
 * the be-financials source. Only `started` is confirmed from the table's
 * column default; `completed`/`failed` mirror the identical lifecycle used by
 * `WarrantsJobStatus` and should be confirmed against the real enum values.
 */
export enum WarrantsFilesJobStatus {
  STARTED = "started",
  COMPLETED = "completed",
  FAILED = "failed",
}

export interface IWarrantsFilesJob {
  id: number
  status: WarrantsFilesJobStatus
  errorMessage: string | null
  startedAt: Dayjs
  endedAt: Dayjs | null
  createdAt: Dayjs

  /** The status enum value rendered for display, e.g. 'Completed'. */
  readonly statusDisplay: string
}
